module.exports = __webpack_public_path__ + "img/upload_info_l_png.316048eb.svg";